import { usePostHog } from 'posthog-js/react';
import { useAuth } from '@hotpot-arcade/fanforge-auth';
import { useCallback, useMemo } from 'react';
import {
  AnalyticsEvent,
  enrichAnonymousProperties,
  enrichAuthenticatedProperties,
  Flags,
} from '@hotpot-arcade/fanforge-core';

// stuff
export function useAnalytics() {
  const posthog = usePostHog();
  const jwtPayload = useAuth((s) => (s.state === 'authenticated' ? s.jwtPayload : null));

  if (!posthog) throw new Error('PostHogProvider is missing');

  const track = useCallback(
    <T extends AnalyticsEvent>(event: T) => {
      try {
        // Enrich based on auth state
        const enrichedProps = jwtPayload
          ? enrichAuthenticatedProperties(event, jwtPayload)
          : enrichAnonymousProperties(event);

        posthog.capture(event.name, enrichedProps);
      } catch (error) {
        // Never let analytics errors crash the app
        console.error('Analytics capture failed:', error);
      }
    },
    [posthog, jwtPayload]
  );

  const getFeatureFlag = useCallback(
    (flag: Flags) => {
      return posthog.getFeatureFlag(flag);
    },
    [posthog]
  );

  const getFeatureFlagPayload = useCallback(
    (flag: Flags) => {
      return posthog.getFeatureFlagPayload(flag);
    },
    [posthog]
  );

  return useMemo(
    () => ({ track, getFeatureFlag, getFeatureFlagPayload, raw: posthog }),
    [track, getFeatureFlag, getFeatureFlagPayload, posthog]
  );
}
